module.exports = __webpack_public_path__ + "img/uphillt.0a124f3b.jpg";